import React, { createContext, useEffect, useState } from 'react';
import { BACKEND_URL, JWT_KEY } from '../config';
import { deleteCustomerAdmin } from '../services/customerService';
import { getWithExpiry } from '../services/localStorageService';

export const NewCustomersContext = createContext();

const PPL_TO_DISPLAY = 25;

const NewCustomersProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [people, setPeople] = useState([]);
  const [filteredPeople, setFilteredPeople] = useState([]);
  const [displayedPeople, setDisplayedPeople] = useState([]);

  const updateNewCustomers = () => {
    setIsLoading(true);
    
    fetch(`${BACKEND_URL}api/v1/customer/admin/newCustomers`, {
      mode: 'cors',
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${getWithExpiry(JWT_KEY)}`,
      },
    })
      .then((response) => response.json())
      .then((people) => {
        people.sort(({ lastName }, { lastName: otherLastName }) =>
          lastName.trim().localeCompare(otherLastName.trim())
        );

        setPeople(people);
        setFilteredPeople(people);
        setDisplayedPeople(people.slice(0, PPL_TO_DISPLAY));
        setIsLoading(false);
      })
      .catch((error) => console.log('No way! ', error));
  }

  useEffect(() => {
    updateNewCustomers();
  }, []);

  const removeCustomer = async (customerIdToRemove) => {
    const { errors } = await deleteCustomerAdmin(customerIdToRemove);

    if (errors) {
      console.log({ errors });
      return;
    }

    setPeople(
      people.filter(({ customerId }) => customerId !== customerIdToRemove)
    );
  };

  const value = {
    isLoading,
    people,
    filteredPeople,
    setFilteredPeople,
    displayedPeople,
    setDisplayedPeople,
    removeCustomer,
    updateNewCustomers,
  };

  return (
    <NewCustomersContext.Provider value={{ ...value }}>
      {children}
    </NewCustomersContext.Provider>
  );
};

export default NewCustomersProvider;
